export default "/imgs/investigation-06.png"